var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49088 10.0285V0.947357C9.49088 0.424151 9.06673 0 8.54352 0C8.02031 0 7.59616 0.424151 7.59616 0.947357V10.0285L4.47661 6.90898C4.10665 6.539 3.50682 6.539 3.13686 6.90898C2.76688 7.27894 2.76688 7.87877 3.13686 8.24873L8.54352 13.6554L13.9503 8.24873C14.3201 7.87877 14.3201 7.27894 13.9503 6.90898C13.5802 6.53902 12.9804 6.53902 12.6103 6.90898L9.49088 10.0285Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.962982 12.3164C1.48619 12.3164 1.91034 12.7406 1.91034 13.2638V14.7795C1.91034 15.512 2.50414 16.1058 3.23664 16.1058H13.847C14.5795 16.1058 15.1733 15.512 15.1733 14.7795V13.2638C15.1733 12.7406 15.5976 12.3164 16.1207 12.3164C16.6438 12.3164 17.0681 12.7406 17.0681 13.2638V14.7795C17.0681 16.5585 15.626 18.0005 13.847 18.0005H3.23664C1.45773 18.0005 0.015625 16.5585 0.015625 14.7795V13.2638C0.015625 12.7406 0.439776 12.3164 0.962982 12.3164Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.01c6bddbbcdf87a40ba696e0485d27ff.svg";
export { ForwardRef as ReactComponent };